import { useState, useCallback } from "react";
import * as api from "../../api";

/* PASO 4 (F3B) — Tienda abierta/cerrada (site status). Movido VERBATIM de App.js. */
export function useSiteStatus(showToast) {
  const [siteStatus, setSiteStatus] = useState({ open: true, reason: "" });
  const [siteStatusForm, setSiteStatusForm] = useState({ reason: "" });
  const [siteStatusBusy, setSiteStatusBusy] = useState(false);

  const loadSiteStatus = useCallback(async () => {
    try {
      const s = await api.getSiteStatus();
      setSiteStatus(s);
      setSiteStatusForm({ reason: s.reason || "" });
    } catch (e) { console.warn("site status load failed:", e); }
  }, []);

  const handleToggleSiteOpen = async () => {
    setSiteStatusBusy(true);
    try {
      const nextOpen = !siteStatus.open;
      const reason = nextOpen ? "" : (siteStatusForm.reason || "Estamos temporalmente fuera de servicio, vuelve pronto.");
      const s = await api.adminSetSiteStatus(nextOpen, reason);
      setSiteStatus(s);
      setSiteStatusForm({ reason: s.reason || "" });
      showToast(
        nextOpen ? "Tienda abierta" : "Tienda cerrada",
        nextOpen ? "Los clientes ya pueden comprar." : "Los clientes verán el mensaje de mantenimiento.",
        "success",
      );
    } catch (err) {
      showToast("Error", err.message || "No se pudo actualizar", "error");
    } finally {
      setSiteStatusBusy(false);
    }
  };

  const handleSaveClosureReason = async () => {
    setSiteStatusBusy(true);
    try {
      const s = await api.adminSetSiteStatus(siteStatus.open, siteStatusForm.reason || "");
      setSiteStatus(s);
      showToast("Motivo actualizado", "El mensaje que verán los clientes se guardó.", "success");
    } catch (err) {
      showToast("Error", err.message || "No se pudo guardar", "error");
    } finally {
      setSiteStatusBusy(false);
    }
  };

  return {
    siteStatus, siteStatusForm, setSiteStatusForm, siteStatusBusy,
    loadSiteStatus, handleToggleSiteOpen, handleSaveClosureReason,
  };
}
